import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { NovaIcon } from 'components/ui/novaIcon';
import { VideoBox } from 'components/common/VideoBox/VideoBox';
import { VideoModal } from 'components/common/VideoBox/VideoModal';
import React, { ReactElement, useState } from 'react';
import { AddIcon, VisibilityIcon } from 'assets/icons/v2';
import { getYoutubeEmbedUrl } from 'utils/youtube';

type Props = {
  videoUrl: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  qrCodeUrl?: string;
  onSelect?: (data: {
    videoUrl: string;
    title: string;
    description?: string;
    thumbnailUrl?: string;
    qrCodeUrl?: string;
  }) => void;
};

export const ModalVideoCard = ({
  videoUrl,
  title,
  description,
  thumbnailUrl,
  qrCodeUrl,
  onSelect,
}: Props): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Flex
        flexDir="column"
        gap="10px"
        border="default"
        borderColor="border.accent"
        borderRadius="10px"
        flexGrow={1}
      >
        <Box
          borderRadius="8px 8px 0 0"
          overflow="hidden"
          flexGrow={1}
          width="100%"
          height={{ base: '110px', md: '160px' }}
          maxHeight={{ base: '110px', md: '160px' }}
          position="relative"
        >
          <VideoBox
            videoUrl={getYoutubeEmbedUrl(videoUrl)}
            videoDescription={description}
            isEmbedded
            thumbnailUrl={thumbnailUrl}
          />
        </Box>
        <Box
          p="0 15px 15px 15px"
          flexGrow={1}
          width="100%"
          display="flex"
          flexDir="column"
          justifyContent="space-between"
        >
          <Text
            textStyle={{ base: 'body.s.regular', md: 'body.s.medium' }}
            color="text.secondary"
            lineClamp={2}
            flexGrow={1}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {title}
          </Text>
          <HStack justifyContent="space-between" alignItems="center" mt="l">
            <Button
              variant="secondaryOutline"
              borderColor="border.accent"
              color="text.secondary"
              textStyle="body.s.regular"
              lineHeight="18px"
              onClick={() => setIsOpen(true)}
              px="26px"
              verticalAlign="center"
              py="xs"
            >
              <NovaIcon icon={VisibilityIcon} size="m" color="icon.tertiary" aria-hidden />
              Vorschau
            </Button>
            <Button
              variant="primary"
              flexWrap="unset"
              textStyle="body.s.regular"
              lineHeight="18px"
              onClick={() => {
                if (onSelect) {
                  onSelect({
                    videoUrl: getYoutubeEmbedUrl(videoUrl),
                    title,
                    description,
                    thumbnailUrl,
                    qrCodeUrl,
                  });
                }
              }}
              px="26px"
            >
              <NovaIcon icon={AddIcon} size="m" aria-hidden />
              Einfügen
            </Button>
          </HStack>
        </Box>
      </Flex>
      <VideoModal
        videoUrl={getYoutubeEmbedUrl(videoUrl)}
        isEmbedded
        isModalOpen={isOpen}
        onModalClose={() => setIsOpen(false)}
        videoDescription={description || ''}
      />
    </>
  );
};
